import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import "./CreateGroupModal.css";
import axios from "axios";
import { toast } from "react-toastify";
import AttachFilesModal from "./AttachFilesModal";
import InsertRangeModal from "./InsertRangeModal";
import Select from "react-select";

const CreateGroupModal = ({
  mode,
  show,
  // handleClose,
  classOptions,
  secondDropdownOptions,
  selectedClass,
  onClassChange,
  selectedRelation,
  setSelectedClass,
  onRelationChange,
  handleGroupSave,
  handleGroupEdit,
  groupData,
  setShowCreateGroupModal,
  groupLoading,
  errors,
}) => {
  const { REACT_APP_API_ENDPOINT } = process.env;

  const [showSecondDropdown, setShowSecondDropdown] = useState(false);
  const [showThirdDropdown, setShowThirdDropdown] = useState(false);
  const [showFourthDropdown, setShowFourthDropdown] = useState(false);
  const [draftedRelations, setDraftedRelations] = useState([]);
  const [selectedSecondOption, setSelectedSecondOption] = useState(null);
  const [selectedThirdOption, setSelectedThirdOption] = useState("");
  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [fourthDropdownOptions, setFourthDropdownOptions] = useState([]);
  const [selectedFourthOption, setSelectedFourthOption] = useState("");
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [isInstanceNamePopupEnabled, setIsInstanceNamePopupEnabled] =
    useState(false);
  const [firstDropdownDisabled, setFirstDropdownDisabled] = useState(false);
  const [secondDropdownDisabled, setSecondDropdownDisabled] = useState(false);
  const [thirdDropdownOptions, setThirdDropdownOptions] = useState(new Set());
  const [thirdDropdownFileAttachNode, setThirdDropdownFileAttachNode] =
    useState(new Set());
  const [showAttachFilesModal, setShowAttachFilesModal] = useState(false);
  const [showRangeModal, setShowRangeModal] = useState(false);
  const [relationValue, setRelationValue] = useState("");
  const [secondRelationValue, setSecondRelationValue] = useState("");
  const [source, setSource] = useState("");
  const [destination, setDestination] = useState("");
  const [isDeleting, setIsDeleting] = useState(false); // Loader state

  const [selectedNode, setSelectedNode] = useState("");
  const [selectedFileNames, setSelectedFileName] = useState([]); // Stores only selected file name
  const [attachedFilesToNode, setAttachedFilesToNode] = useState({});
  const [attachmentNode, setAttachmentNode] = useState(""); // Track files attached to nodes

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      padding: "4px 8px", // Reduce padding to make it smaller
      fontSize: "0.875rem", // Reduce font size
      height: "30px", // Adjust height for a smaller input box
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0", // Remove extra padding inside the container
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "4px", // Reduce padding around the dropdown indicator (arrow)
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "4px", // Reduce padding around the clear indicator (X button)
    }),
    menu: (base) => ({
      ...base,
      fontSize: "0.875rem", // Reduce font size of dropdown items
    }),
    option: (base) => ({
      ...base,
      padding: "6px 8px", // Reduce option padding
    }),
  };

  // Initialize edit mode
  useEffect(() => {
    if (mode === "edit" && groupData) {
      setGroupName(groupData.name || "");
      setGroupDescription(groupData.description || "");
      setDraftedRelations(
        groupData.relations_string ? groupData.relations_string.split(", ") : []
      );
      onClassChange(groupData.start_node || "");

      setSelectedClass(groupData.start_node);
      if (groupData.relations_string) {
        const nodeMatches =
          groupData.relations_string.match(/\b(\w+)\(:\w+\)/g);
        const uniqueNodes = nodeMatches ? Array.from(new Set(nodeMatches)) : [];
        // setThirdDropdownOptions(new Set(uniqueNodes));
        setThirdDropdownFileAttachNode(new Set(uniqueNodes));
      }

      setIsInstanceNamePopupEnabled(groupData.name_required === "true");
      setShowThirdDropdown(true);
      setFirstDropdownDisabled(true);
      // setSecondDropdownDisabled(true);
    }
  }, [mode, groupData]);

  useEffect(() => {
    setShowSecondDropdown(!!selectedClass);
  }, [selectedClass]);

  const handleDraftRelation = () => {
    if (!selectedSecondOption) {
      toast.error("Please select values from dropdown");
      return;
    }
    if (isInstanceNamePopupEnabled) {
      if (showFourthDropdown && selectedFourthOption) {
        setShowRangeModal(true);
      } else {
        setShowRangeModal(true);
      }
    } else {
      if (showFourthDropdown && selectedFourthOption) {
        const selectedOption = fourthDropdownOptions.find(
          (opt) => opt.value === selectedFourthOption
        );

        if (selectedOption) {
          const [relation, classes] = selectedOption.display.split(": ");
          const [srcClass, dstClass] = classes.split(" --> ");

          let newDraftedRelation = `${srcClass}-${relation}${
            relationValue ? "=" + relationValue : ""
          }-${dstClass},\n`;
          const draftedClass = dstClass === selectedClass ? srcClass : dstClass;

          setDraftedRelations((prev) => [...prev, newDraftedRelation]);
          setThirdDropdownOptions((prev) => new Set([...prev, draftedClass]));
          setThirdDropdownFileAttachNode(
            (prev) => new Set([...prev, dstClass])
          );

          setSelectedThirdOption("");
          setSelectedFourthOption("");
          setFourthDropdownOptions([]);
          setShowFourthDropdown(false);
          setRelationValue("");
        }
      } else {
        let newDraftedRelation = `${selectedSecondOption.raw.src_classname}-${
          selectedSecondOption.raw.relation
        }${secondRelationValue ? "=" + secondRelationValue : ""}-${
          selectedSecondOption.raw.dst_classname
        },\n`;

        setDraftedRelations((prev) => [...prev, newDraftedRelation]);

        const draftedClass =
          selectedSecondOption.raw.dst_classname === selectedClass
            ? selectedSecondOption.raw.src_classname
            : selectedSecondOption.raw.dst_classname;
        setThirdDropdownOptions((prev) => new Set([...prev, draftedClass]));

        setThirdDropdownFileAttachNode(
          (prev) =>
            new Set([
              ...prev,
              selectedSecondOption.raw.src_classname,
              selectedSecondOption.raw.dst_classname,
            ])
        );

        setShowThirdDropdown(true);
        setFirstDropdownDisabled(true);
        // setSecondDropdownDisabled(true);
      }
    }
  };

  const handleNamedDraftRelation = (source, destination) => {
    if (showFourthDropdown && selectedFourthOption) {
      const selectedOption = fourthDropdownOptions.find(
        (opt) => opt.value === selectedFourthOption
      );

      if (selectedOption) {
        const [relation, classes] = selectedOption.display.split(": ");
        const [srcClass, dstClass] = classes.split(" --> ");

        let newDraftedRelation = `${source}(:${srcClass})->${relation}`;
        if (relation === "IsAnswerFor" && relationValue) {
          newDraftedRelation += `=${relationValue}`;
        }
        newDraftedRelation += `->${destination}(:${dstClass}),\n`;

        setDraftedRelations((prev) => [...prev, newDraftedRelation]);

        const draftedClass =
          dstClass === selectedClass
            ? `${source}(:${selectedSecondOption.raw.src_classname})`
            : `${destination}(:${selectedSecondOption.raw.dst_classname})`;
        setThirdDropdownOptions((prev) => new Set([...prev, draftedClass]));
        setThirdDropdownFileAttachNode(
          (prev) => new Set([...prev, draftedClass])
        );

        setSelectedThirdOption("");
        setSelectedFourthOption("");
        setFourthDropdownOptions([]);
        setShowFourthDropdown(false);
        setRelationValue("");
      }
    } else if (selectedSecondOption) {
      let newDraftedRelation = `${source}(:${selectedSecondOption.raw.src_classname})->${selectedSecondOption.raw.relation}`;
      if (
        selectedSecondOption.raw.relation === "IsAnswerFor" &&
        secondRelationValue
      ) {
        newDraftedRelation += `=${secondRelationValue}`;
      }
      newDraftedRelation += `->${destination}(:${selectedSecondOption.raw.dst_classname}),\n`;
      setDraftedRelations((prev) => [...prev, newDraftedRelation]);

      const draftedClass =
        selectedSecondOption.raw.dst_classname === selectedClass
          ? `${source}(:${selectedSecondOption.raw.src_classname})`
          : `${destination}(:${selectedSecondOption.raw.dst_classname})`;
      setThirdDropdownOptions(
        (prev) =>
          new Set([
            ...prev,
            draftedClass, // Adds b(:Agreement)
          ])
      );
      setThirdDropdownFileAttachNode(
        (prev) =>
          new Set([
            ...prev,
            `${source}(:${selectedSecondOption.raw.src_classname})`,
            `${destination}(:${selectedSecondOption.raw.dst_classname})`,
          ])
      );

      setShowThirdDropdown(true);
      setFirstDropdownDisabled(true);
      // setSecondDropdownDisabled(true);
    }

    setShowRangeModal(false);
  };

  const handleThirdDropdownChange = async (value) => {
    setSelectedThirdOption(value);
    if (value && value !== "") {
      try {
        const response = await axios.post(
          `${REACT_APP_API_ENDPOINT}/name/range-domain`,
          { class_name: removeDynamicPrefix(value) }
        );
        if (response.data) {
          const formattedOptions = response.data.map((item) => ({
            value: item.dst_classname,
            display: `${item.relation}: ${item.src_classname} --> ${item.dst_classname}`,
            raw: item,
          }));
          setFourthDropdownOptions(formattedOptions);
          setShowFourthDropdown(true);
          setSecondDropdownDisabled(true);
        }
      } catch (error) {
        console.error("Error fetching fourth dropdown options:", error);
        toast.error("Failed to fetch additional options");
      }
    } else {
      setSecondDropdownDisabled(false);
    }
  };

  const getThirdDropdownOptions = (isAttach) => {
    if (isAttach) {
      return Array.from(thirdDropdownFileAttachNode);
    }
    return Array.from(thirdDropdownOptions);
  };

  const selectedSecondOptionObject = secondDropdownOptions.find(
    (opt) => opt.display === (selectedSecondOption?.display || "")
  );

  const selectedFourthOptionObject = fourthDropdownOptions.find(
    (opt) => opt.value === selectedFourthOption
  );

  const handleSaveGroup = () => {
    if (!groupName) {
      toast.error("Group name is required.");
      return;
    }

    if (!selectedClass) {
      toast.error("start node are required.");
      return;
    }

    const groupData = {
      name: groupName,
      relations_string: draftedRelations.join(""),
      description: groupDescription,
      start_node: selectedClass,
      name_required: isInstanceNamePopupEnabled,
      related_nodes: Array.from(thirdDropdownOptions)
        .map((option) => `<option value=${option}>${option}</option>`)
        .join(""),
      instance_name_popup_enabled: isInstanceNamePopupEnabled,
      attached_files: attachedFiles,
    };

    if (mode === "edit") {
      handleGroupEdit(groupData);
    } else {
      handleGroupSave(groupData, attachedFilesToNode);
    }
  };

  const handleFilesAttached = (newFiles) => {
    const updatedFiles = newFiles.map((file) => ({
      fileName: file.name || "",
      newFileName: `${selectedNode}^${file.name || ""}`,
    }));

    setAttachedFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
  };

  const handleCheckboxChange = (fileName) => {
    setSelectedFileName((prevSelected) => {
      if (prevSelected.includes(fileName)) {
        // If file is already selected, remove it from the array
        return prevSelected.filter((name) => name !== fileName);
      } else {
        // If file is not selected, add it to the array
        return [...prevSelected, fileName];
      }
    });
  };

  const handleDelete = async () => {
    if (selectedFileNames.length === 0) {
      toast.error("Please select at least one file to delete.");
      return;
    }

    setIsDeleting(true); // Show loader
    try {
      await Promise.all(
        selectedFileNames.map(async (fileName) => {
          const sanitizedFileName = fileName;
          // .replace(/\s+/g, "_")
          // .replace(/[()]/g, "");
          const encodedFileName = encodeURIComponent(sanitizedFileName);

          const response = await fetch(
            `${REACT_APP_API_ENDPOINT}/document/${encodedFileName}/`,
            { method: "DELETE" }
          );
          setAttachedFilesToNode((prev) => {
            const updatedFilesToNode = { ...prev };
            for (const [node, attachedFileName] of Object.entries(
              updatedFilesToNode
            )) {
              if (attachedFileName === sanitizedFileName) {
                delete updatedFilesToNode[node];
              }
            }
            return updatedFilesToNode;
          });

          if (!response.ok) {
            throw new Error(`Failed to delete file: ${fileName}`);
          }
        })
      );

      // Remove successfully deleted files from state
      setAttachedFiles((prevFiles) =>
        prevFiles.filter((file) => !selectedFileNames.includes(file.fileName))
      );

      setSelectedFileName([]); // Clear selected file names
      toast.success("Selected files deleted successfully.");
    } catch (error) {
      console.error("Error deleting files:", error);
      toast.error("Error deleting files.");
    } finally {
      setIsDeleting(false); // Hide loader
    }
  };

  const handleClose = () => {
    setShowCreateGroupModal(false);
    handleReset();
    clearNameAndDiscription();
  };

  const clearNameAndDiscription = () => {
    setGroupName("");
    setGroupDescription("");
  };

  const handleReset = () => {
    setDraftedRelations([]);
    setSelectedSecondOption(null);
    setSelectedThirdOption("");
    setSelectedFourthOption("");
    setFourthDropdownOptions([]);
    setShowSecondDropdown(false);
    setShowThirdDropdown(false);
    setShowFourthDropdown(false);
    setAttachedFiles([]);
    setFirstDropdownDisabled(false);
    setSecondDropdownDisabled(false);
    setThirdDropdownOptions(new Set());
    setThirdDropdownFileAttachNode(new Set());
    onClassChange("");
    setAttachedFilesToNode({});
    setIsInstanceNamePopupEnabled(false);
    setRelationValue("");
    setSecondRelationValue("");
  };

  function removeDynamicPrefix(input) {
    // Regular expression to match any prefix followed by '(:' and any trailing ')'
    const regex = /^.*\(:|:?\)$/g;

    // Replace the matched part with an empty string
    return input?.replace(regex, "");
  }

  const handleRelationsChange = (e) => {
    // Update draftedRelations based on textarea value split by newlines
    setDraftedRelations(e.target.value.split(", "));
  };

  const classDropdownOptions = classOptions.map((className) => ({
    value: className,
    label: className,
  }));

  const secondDropdownOptionsObject = secondDropdownOptions.map((option) => ({
    value: option.display,
    label: option.display,
  }));

  const thirdDropdownOptionsObject = getThirdDropdownOptions().map(
    (option) => ({
      value: option,
      label: option,
    })
  );

  const fourthDropdownOptionsObject = fourthDropdownOptions.map((option) => ({
    value: option.value,
    label: option.display,
  }));

  return (
    <>
      <Modal
        show={show}
        onHide={() => handleClose()}
        className="create-group-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "18px" }}>
            {mode === "edit" ? "Edit Group" : "Create Group"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="create-group-container p-0">
            <div className="create-group-header">
              <span className="create-group-heading fw-normal fs-14">
                <input
                  type="checkbox"
                  checked={isInstanceNamePopupEnabled}
                  onChange={(e) =>
                    setIsInstanceNamePopupEnabled(e.target.checked)
                  }
                  className="instance-name-checkbox m-0"
                  disabled={mode === "edit" || firstDropdownDisabled}
                />
                Please select the check-box to enable the instance name popup
                for this design.
              </span>
            </div>

            <div className="create-group-content gap-0 ">
              <div className="create-group-panel left-panel p-15">
                <div className="form-group ">
                  <input
                    type="text"
                    id="groupName"
                    className="form-control"
                    placeholder="Enter group name"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                  {errors.groupName && (
                    <small className="text-danger">{errors.groupName}</small>
                  )}
                </div>

                <div className="form-group mt-3">
                  <textarea
                    id="description"
                    className="form-control"
                    rows="3"
                    placeholder="Enter group description"
                    value={groupDescription}
                    onChange={(e) => setGroupDescription(e.target.value)}
                  />
                  {errors.description && (
                    <small className="text-danger">{errors.description}</small>
                  )}
                </div>

                <div className="form-group mt-3">
                  <Select
                    value={
                      selectedClass
                        ? classDropdownOptions.find(
                            (option) => option.value === selectedClass
                          )
                        : null
                    }
                    onChange={(selectedOption) =>
                      onClassChange(selectedOption ? selectedOption.value : "")
                    }
                    options={classDropdownOptions}
                    isDisabled={firstDropdownDisabled}
                    placeholder="-- Select a class --"
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    isClearable
                    styles={customStyles}
                  />
                </div>

                {showSecondDropdown && (
                  <div className="form-group mt-3">
                    <Select
                      id="secondDropdown"
                      value={
                        selectedSecondOption
                          ? {
                              value: selectedSecondOption.display,
                              label: selectedSecondOption.display,
                            }
                          : null
                      }
                      onChange={(selectedOption) => {
                        const selectedData = secondDropdownOptions.find(
                          (opt) => opt.display === selectedOption?.value
                        );
                        setSelectedSecondOption(selectedData);
                        onRelationChange(selectedData);
                      }}
                      options={secondDropdownOptionsObject}
                      isDisabled={secondDropdownDisabled}
                      placeholder="-- Select Relations --"
                      menuPortalTarget={document.body} // Render menu in the body
                      // isClearable
                      menuPlacement="auto"
                      styles={customStyles}
                    />
                  </div>
                )}
                {selectedSecondOptionObject?.raw?.relation ===
                  "IsAnswerFor" && (
                  <div className="form-group mt-3">
                    <input
                      type="text"
                      id="secondRelationValue"
                      className="form-control"
                      placeholder="Enter value"
                      value={secondRelationValue}
                      onChange={(e) => setSecondRelationValue(e.target.value)}
                    />
                  </div>
                )}

                {showThirdDropdown && (
                  <div className="form-group mt-3">
                    <Select
                      id="thirdDropdown"
                      value={
                        selectedThirdOption
                          ? {
                              value: selectedThirdOption,
                              label: selectedThirdOption,
                            }
                          : null
                      }
                      onChange={(selectedOption) => {
                        handleThirdDropdownChange(selectedOption?.value);
                      }}
                      options={thirdDropdownOptionsObject}
                      isClearable
                      placeholder="-- Select Related Nodes --"
                      menuPortalTarget={document.body} // Render menu in the body
                      menuPlacement="auto"
                      styles={customStyles}
                    />
                  </div>
                )}

                {showFourthDropdown && fourthDropdownOptions.length > 0 && (
                  <div className="form-group mt-3">
                    <Select
                      id="fourthDropdown"
                      value={
                        selectedFourthOption
                          ? {
                              value: selectedFourthOption,
                              label: selectedFourthOption,
                            }
                          : null
                      }
                      onChange={(selectedOption) => {
                        setSelectedFourthOption(selectedOption?.value || "");
                      }}
                      options={fourthDropdownOptionsObject}
                      isClearable
                      placeholder="-- Select Additional Options --"
                      menuPortalTarget={document.body} // Render menu in the body
                      menuPlacement="auto"
                      styles={customStyles}
                    />
                  </div>
                )}

                {selectedFourthOptionObject?.raw?.relation ===
                  "IsAnswerFor" && (
                  <div className="form-group mt-3">
                    <input
                      type="text"
                      id="relationValue"
                      className="form-control"
                      placeholder="Enter value"
                      value={relationValue}
                      onChange={(e) => setRelationValue(e.target.value)}
                    />
                  </div>
                )}

                <div className="form-group mt-0 mb-0">
                  <Button
                    className="cancell-button cancell-button-container btn btn-primary m-0"
                    onClick={handleDraftRelation}
                    // disabled={!selectedSecondOption}
                  >
                    Draft This Relation
                  </Button>
                </div>
              </div>

              <div className="create-group-divider m-0"></div>

              <div className="create-group-panel right-panel d-flex flex-column">
                <h6>Drafted Relations</h6>
                <div className="form-group flex-grow-1">
                  <textarea
                    id="draftedRelations"
                    className="form-control h-100"
                    rows="7"
                    value={draftedRelations.join("")}
                    onChange={handleRelationsChange}
                    placeholder="Drafted Relations"
                  />
                </div>

                <div className="form-group mt-0 mb-0 d-flex align-items-center gap-3">
                  {mode !== "edit" && (
                    <Button
                      className="cancell-button cancell-button-container m-0"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                  )}

                  {isInstanceNamePopupEnabled && mode !== "edit" && (
                    <>
                      <Button
                        className="cancell-button cancell-button-container m-0"
                        onClick={() => setShowAttachFilesModal(true)}
                      >
                        Attach Files
                      </Button>
                      <div className="form-group mt-0 mb-0 d-flex align-items-center gap-3">
                        {isDeleting ? (
                          <div className="loader">
                            <Spinner animation="border" size="sm" />
                            <span> Deleting files...</span>
                          </div> // Display loader when isDeleting is true
                        ) : (
                          <>
                            <Button
                              className="cancell-button cancell-button-container m-0"
                              onClick={handleDelete}
                              disabled={
                                isDeleting || selectedFileNames.length === 0
                              }
                            >
                              <MdDelete
                                className="text-danger"
                                style={{ marginBottom: "2px" }}
                                size={20}
                              />
                            </Button>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
                {attachedFiles.map((file, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedFileNames.includes(file.fileName)} // Multiple files can be selected
                      onChange={() => handleCheckboxChange(file.fileName)}
                      className="instance-name-checkbox"
                    />
                    <span style={{ marginLeft: "8px" }}>
                      {file.newFileName}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleSaveGroup}
            className="create-button"
            disabled={groupLoading}
          >
            {groupLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                {mode === "edit" ? "Updating..." : "Saving..."}
              </>
            ) : mode === "edit" ? (
              "Update"
            ) : (
              "Save / Create"
            )}
          </Button>
          <Button
            variant="secondary"
            onClick={() => handleClose()}
            className="cancell-button cancell-button-container"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <AttachFilesModal
        show={showAttachFilesModal}
        handleClose={() => setShowAttachFilesModal(false)}
        nodeOptions={getThirdDropdownOptions(true)}
        handleFilesAttached={handleFilesAttached}
        groupName={groupName}
        setSelectedNode={setSelectedNode}
        selectedNode={selectedNode}
        attachedFiles={attachedFilesToNode}
        attachmentNode={attachmentNode}
        setAttachedFiles={setAttachedFilesToNode}
        setAttachmentNode={setAttachmentNode}
      />

      <InsertRangeModal
        show={showRangeModal}
        handleClose={() => setShowRangeModal(false)}
        handleNamedDraftRelation={handleNamedDraftRelation}
        setSource={setSource}
        setDestination={setDestination}
        source={source}
        destination={destination}
      />
    </>
  );
};

export default CreateGroupModal;
